import { Balloon } from "features/無料占いBot/components/Balloon";
import { useState, useEffect, FC, useCallback } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { Colors } from "shared/styles";
import { useScroll } from "shared/hooks/useScroll";

const balloonCss = {
  balloon: {
    background: Colors.blue["01"],
    color: "#070c23",
  },
};

interface Props {
  delay?: number;
  icon?: string;
  className?: string;
}

export const Delay: FC<Props> & { eager?: boolean } = ({
  children,
  delay = 2500,
  icon,
  ...rest
}) => {
  const [shouldRender, setShouldRender] = useState(Delay.eager);

  const { scrollToBottom } = useScroll();

  const setTimer = useCallback(() => {
    setTimeout(() => {
      setShouldRender(true);
    }, delay);
  }, [delay]);

  useEffect(() => {
    setTimer();
    return setTimer();
  }, [setTimer]);

  useEffect(() => {
    if (shouldRender) scrollToBottom();
  }, [shouldRender, scrollToBottom]);

  return (
    <div tw="mt-[30px]" {...rest}>
      {shouldRender ? (
        children
      ) : (
        <Balloon position="left" icon={icon} classes={balloonCss} date={null}>
          <PulseLoader color="rgba(0,0,0,0.5)" speedMultiplier={0.8} size={4} />
        </Balloon>
      )}
    </div>
  );
};

Delay.eager = false;
